<template>
  <b-overlay :show="isLoading" rounded="lg">
    <b-card title="Kiosk Warhouse">
      <b-modal v-model="modalConfirmation" :title="modalTitle">
        <!-- Alert before Delete PO-->
        <b-container>
          <b-row>
            <b-col cols="12" >
              <div class="d-flex">
                Are you sure want to {{ messageModal }} this {{selectPO.PONumber}} ?
              </div>
            </b-col>
          </b-row>
        </b-container>
        <template #modal-footer>
          <div class="w-100 d-flex justify-content-center align-items-center">
            <b-button variant="danger" class="ml-1" @click="confirmEdit">Confirm</b-button>
          </div>
        </template>
      </b-modal>
      <b-modal v-model="modalInfo" title="Stock Check Complete" hide-header-close no-close-on-backdrop 
  no-close-on-esc  hide-footer centered>
        <div class="d-flex flex-column align-items-center">
          <p class="text-center">Please bring items for PO {{ modalInfoMessage }} to counter to verify item type.</p>
          <div class="d-flex justify-content-center mt-2">
            <b-button variant="primary" @click="handleInfoClose">OK</b-button>
          </div>
        </div>
      </b-modal>

      <!-- End of Modal Needed on this page-->
      <b-col cols="12">
        <b-row>
          <b-col cols="4">
            <b-form-input
              class="mt-2"
              @input="(value) => doFiltering(value)"
              v-model="search"
              type="search"
              placeholder="Type to Search Order Number"
            />
          </b-col>
          <b-col cols="4">

          </b-col>
          <b-col cols="4">
            <b-button
              class="mt-2 float-right"
              variant="primary"
              @click="refresfMethod()"
            >
              Refresh Kiosk PO
            </b-button>
          </b-col>
          
          <b-col style="margin: 15px 0 0 0" cols="12">
            <b-table
              class="custom-row-height"
              :busy.sync="tableLoading"
              show-empty
              :items="mappedPurchase"
              :fields="fields"
              thead-class="compact-header"
              tbody-class="compact-body"
              responsive
            >
              <template #cell(item)="row">
                <div v-for="(model, index) in row.item.item" :key="index" style="margin-bottom: 6px;">
                  {{ model }}
                </div>
              </template>

              <template #cell(qty)="row">
                <div v-for="(quantity, index) in row.item.qty" :key="index" style="margin-bottom: 6px;">
                  {{ quantity }}
                </div>
              </template>

              <template #cell(itemStatus)="row">
                <div v-for="(status, index) in row.item.status" :key="index" style="margin-bottom: 6px;">
                  {{ status == "Safe" ? 'Available' : (status == "Replacement Item Safe" ? "Replacement Available" : status) }}
                </div>
              </template>

              <template #cell(createdAt)="row">
                {{ dates(row.item.createdAt) }}
              </template>

              <template #cell(updatedAt)="row">
                {{ dates(row.item.updatedAt) }}
              </template>

              <template #cell(status)="row">
                {{ statusParser(row.item) }}
              </template>

              <template #cell(actions)="row">
                <div> 
                  <b-button v-if="row.item.orderStatus == 'Checking' && !row.item.status.every(status => status === 'Safe')" size="sm" @click="detailPO(row)" variant="info" class="mr-1">
                    Check Stock
                  </b-button>
                </div>
              </template>
            </b-table>
          </b-col>

          <b-col cols="12">
            <b-pagination
              :total-rows="totalRows"
              :per-page="perPage"
              @change="onPageChange"
              v-model="currentPage"
              style="float: right"
            />
          </b-col>
        </b-row>
        
      </b-col>
      
    </b-card>
  </b-overlay>
  </template>
  
  <script>
  import { mapGetters, mapActions } from 'vuex';
  import {userAccess,dateFormat} from '@/utils/utils'
  import lodash from 'lodash';
  import axios from '@/axios';
  
  export default {
    data() {
      return {
        fields: [
          { key: 'rspOrderNumber', label: 'Order Number', filterable: true, sortable: true },
          { key: 'status', label: 'Status', filterable: true, sortable: true, },
          { key: 'item', label: "Item Model", filterable: true, sortable: true},
          { key: 'qty', label: "QTY", filterable: true, sortable: true},
          { key: 'itemStatus', label: "Check Stock Status", filterable: true, sortable: true},
          { key: 'createdAt', label:'Kiosk PO Created Date', filterable: true, sortable: true},
          { key: 'actions', label: 'Actions' },
        ],
        search: '',
        currentPage: 1,
        perPage: 10,
        totalRows: 1,
        tableLoading: true,
        modalDelete: false,
        selectPO:'',
        sapStatus: 'undefined',
        modalTitle: "",
        modalConfirmation: false,
        messageModal : "",
        intervalId: null,
        isPolling : false,
        modalInfo: false,
        modalInfoMessage: "",
        isLoading: false,
      }
    },
    beforeDestroy() {
      this.clearPollingInterval();
    },
    mounted() {
      const toastMsg = sessionStorage.getItem("toastMessage");
      const toastMessageError = sessionStorage.getItem("toastMessageError");
      if (toastMsg) {
        this.modalInfoMessage = toastMsg
        this.modalInfo = true
      }
      
      if (toastMessageError) {
        this.$bvToast.toast(toastMsg, {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
        sessionStorage.removeItem("toastMessageError"); // agar tidak muncul lagi saat reload
      }

      this.$store.dispatch("dealer/getCurrentDealer"); 
      this.$store
        .dispatch('auth/fetchUser')
        .catch(err => console.log(err))
      
      this.fetchLatest()
      this.loopGetLatest()
      
    },
    computed: {
      ...mapGetters({
        purchase: 'purchase/purchase',
      }),
      mappedPurchase(){
        return this.purchase.map(item => {
          return {
            ...item,
            rspOrderNumber: item.PONumber.includes('*') ? item.PONumber.substring(0, 13) : item.PONumber,
            customerPo: item.PONumber.includes('*') ? item.PONumber.substring(14) : "",
            item: item.items.map(x => x.model),
            qty: item.items.map(x => x.updatedQty? x.updatedQty : (x.updatedReplacementQty? x.updatedReplacementQty : x.qty)),
            status : item.items.map(x => x.status ? x.status : "Not Checked Yet")
          }
        })
      },
      currentDealer() {
        var tempDealer = this.$store.getters["dealer/getCurrentDealers"]
        
        if(tempDealer === null || tempDealer === undefined){
          tempDealer = {
            status : "Not Allowed"
          }
        }else{
          tempDealer = {
            status : "Allowed"
          }
        }
        return tempDealer
      },
      user() {
        return this.$store.getters['auth/getActiveUser'];
      },
      permission() {
        //console.log(userAccess("Order", "order_menu"));
        
        return userAccess("Kiosk Warehouse", "kioskWarehouse_menu");
      },
      checkPermissionAdd(){
        let tempPermission = false
        //console.log('currentDealer',this.currentDealer);
        if (this.currentDealer.status!=='Not Allowed' && this.permission.add){
          tempPermission = true
        }
  
        if(this.user.roleRef){
          if(this.user.roleRef.name==="Super Admin"||this.permission.add){
            tempPermission = true
          }
          
          
        }
        return tempPermission
      }
    },
    methods: {
      ...mapActions({
        getPurchase: 'purchase/getPurchase',
        editStatusPO: 'purchase/editStatusKioskPo'
      }),
      handleInfoClose() {
        this.modalInfo = false;
        sessionStorage.removeItem("toastMessage"); // agar tidak muncul lagi saat reload
      },
      statusParser(item){
        var orderStatus = item.orderStatus;
  
        if(orderStatus === 'Draft'){
          return 'Draft'
        }else if(orderStatus === 'PO Fail'){
          return 'Admin Review'
        }
  
        var status = item.orderStatus;
        switch(status) {
          case '':
            return 'Created'
          default:
            return `${status}`
        }
      },
      refresfMethod() {
        this.isLoading = true;
        this.getPurchase({ 
          search: (this.search!="")?this.search:undefined,
          page: this.currentPage, 
          entry: this.perPage,
          orderStatus: 'ALL', 
          allAccess: this.permission.all, 
          kioskFlag: true })
        .then((data) => {
          this.processMetadata(data.metadata);
          this.isLoading = false;
        });
      },
      async fetchLatest(){
        try {
          await this.getPurchase({ 
            search: (this.search!="")?this.search:undefined,
            page: this.currentPage, 
            entry: this.perPage,
            orderStatus: 'ALL', 
            allAccess: this.permission.all, 
            kioskFlag: true, 
            kioskFlag: true })
          .then((data) => this.processMetadata(data.metadata));
        } catch (err) {
          console.error(err);
        }
      },
      loopGetLatest(){
        if(this.isPolling || this.intervalId) return;
        this.isPolling = true;
        this.intervalId = setInterval(async () => {
          await this.fetchLatest();
        }, 10000);
      },
      clearPollingInterval() {
        if (this.intervalId) {
          clearInterval(this.intervalId);
          this.intervalId = null;
          this.isPolling = false;
        }
      },
      doFiltering: lodash.debounce(function(value) {
        this.search = value;
        this.currentPage = 1;
        this.getPurchase({ 
          search: (this.search!="")?this.search:undefined,
          page: this.currentPage, 
          entry: this.perPage,
          orderStatus: 'ALL',
          sapStatus: this.sapStatus !== 'undefined' ? this.sapStatus : undefined,
          allAccess: this.permission.all,
          kioskFlag : true
        }).then((data) => this.processMetadata(data.metadata));
      }, 500),
      statusFiltering: lodash.debounce(function(value) {
        this.sapStatus = value;
        this.currentPage = 1;
        
        let params = {
          search: (this.search!="")?this.search:undefined,
          page: this.currentPage,
          entry: this.perPage,
          allAccess: this.permission.all
        };
  
        if (value === 'DRAFT' || value === 'PO Fail') {
          params = {
            ...params,
            orderStatus: value,
            sapStatus: undefined
          };
        } else {
          params = {
            ...params, 
            orderStatus: 'ALL',
            sapStatus: value !== 'undefined' ? value : undefined
          };
        }
  
        this.getPurchase(params).then((data) => this.processMetadata(data.metadata));
      }, 500),
      dates(date) {
        //console.info(date);
        return dateFormat(date);
      },
      onPageChange(page) {
        this.currentPage=page;
  
        this.getPurchase({ 
          search: (this.search!="")?this.search:undefined,
          page: this.currentPage, 
          entry: this.perPage
          ,orderStatus: 'ALL', allAccess: this.permission.all, kioskFlag : true
        }).then((data) => this.processMetadata(data.metadata));
      },
      processMetadata(metadata) {
        let { totalData } = metadata;
        this.totalRows = totalData;
        this.tableLoading = false;
      },
      deleteDraft(row){
        this.modalDelete = true;
        this.selectPO = row;
        // console.log(this.selectPO);
      },
      confirmEdit() {
        this.modalConfirmation = false
        let statusChange = ''
        if (this.messageModal == "Cancel") {
          statusChange = "Cancelled"
        }else if(this.messageModal == "Change status to need edit"){
          statusChange = "Need Edit"
        }else if(this.messageModal == "Change status to awaiting acknowledgement"){
          statusChange = "Awaiting Acknowledgement"
        }
        let payloadData = { status : statusChange}
        this.editStatusPO({ id : this.selectPO._id, data : payloadData})
        .then(async (response) => {
          this.getPurchase({ 
            page:this.currentPage, 
            entry:this.perPage,
            orderStatus: 'ALL', 
            allAccess: this.permission.all, 
            kioskFlag: true, })
          .then((data) => this.processMetadata(data.metadata));

          this.$bvToast.toast(`Edit Status Kiosk Purchase Order to ${statusChange} Successfully`, {
            title: "Success",
            variant: "success",
            solid: true,
          });
        })
        .catch(async (e) => {
          console.log(e);
          this.$bvToast.toast("Edit status Kiosk Purchase Order Failed", {
              title: "Failed",
              variant: "danger",
              solid: true,
            });
        });
      },
      detailPO(row) {
        this.clearPollingInterval();
        let idOrder = row.item._id;
        this.$router.push({ name: 'kiosk-warehouse-detail', params: {  id: idOrder } });
      },
      cancelOrder(row) {
        this.modalConfirmation = true
        this.modalTitle = "Cancel Kiosk PO"
        this.messageModal = "Cancel"
        this.selectPO = row.item
      },
      needEditOrder(row) {
        this.modalConfirmation = true
        this.modalTitle = "Change to Need Edit"
        this.messageModal = "Change status to need edit"
        this.selectPO = row.item
      },
      awaitingAcknowledgement(row) {
        this.modalConfirmation = true
        this.modalTitle = "Change to Awaiting Acknowledgement"
        this.messageModal = "Change status to awaiting acknowledgement"
        this.selectPO = row.item
      },
      editDraft(row) {
        this.$router.push(`/order/draft/edit/${row.item._id}`);
      },
    },
    created() {
      document.title = 'Kiosk PO | RSP';
  
      
      this.getPurchase({ page:this.currentPage, entry:this.perPage,orderStatus: 'ALL', allAccess: this.permission.all, kioskFlag : true })
      .then((data) => this.processMetadata(data.metadata));
    },
  }
  </script>
  <style lang="scss">
    .custom-row-height {
      min-height: 120px; /* Adjust this value as needed */
    }
    .compact-header {
      th {
        padding: 0.4rem 0.3rem !important;
        font-size: 0.7rem !important; /* Added !important */
      }
    }
    
    /* Increase specificity by targeting the table element */
    .b-table.table thead.compact-header th {
      font-size: 0.7rem !important;
      padding: 0.4rem 0.3rem !important;
    }
    
    .compact-body {
      td {
        padding: 0.3rem !important;
        font-size: 0.9rem;
      }
    }

    .dropdown-show{
      overflow-y: auto;
      height: 100px;
    }
  </style>
  